import { cn } from "@/lib/utils.ts";
import type { TextMessageParticipant } from "@/types/artifacts.ts";
import { AvatarWithFallback } from "@/components/ui/avatar.tsx";
import { ParticipantPill } from "@/components/ui/participant-pill.tsx";

const TextMessageParticipantPill = ({
  participant,
  className,
}: {
  participant: TextMessageParticipant;
  className?: string;
}) => {
  return (
    <ParticipantPill
      participant={participant}
      variant="email"
      showAvatar={true}
      showParticipantStatus={false}
      isExternal={true}
      className={cn("w-fit", className)}
    />
  );
};

export const FromDisplay = ({ from }: { from: TextMessageParticipant }) => {
  return (
    <div className="flex flex-row gap-2 text-sm items-center">
      <div className="font-medium w-10 shrink-0">From:</div>
      <div className="flex flex-row items-center gap-1 h-6 px-1 py-3 rounded-full border border-gray-200">
        <AvatarWithFallback
          size="sm"
          person={{
            name: from.name,
            picture: from.picture,
            value: from.value,
          }}
        />
        <div className="text-xs truncate pr-1">{from.name || from.value}</div>
      </div>
    </div>
  );
};

export const RecipientsSection = ({ recipients }: { recipients: TextMessageParticipant[] }) => {
  return (
    <div className="flex flex-col gap-2 text-sm">
      <div className="font-medium">To:</div>
      <div className="flex flex-row gap-1 flex-wrap min-w-0">
        {recipients.map((p) => (
          <TextMessageParticipantPill key={p.id} participant={p} />
        ))}
      </div>
    </div>
  );
};
